import { jsx as r } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import { MaskInput as m } from "../MaskInput/MaskInput.mjs";
import "../MaskInput/MaskBase.mjs";
import { DollarSignIcon as p } from "../../icons/componentIcons.mjs";
const i = a((t, o) => {
  const { name: n, ...e } = t;
  return /* @__PURE__ */ r(
    m,
    {
      ref: o,
      name: n,
      decimalScale: 2,
      placeholder: "0.00",
      inputLeftAddon: /* @__PURE__ */ r(p, { className: "currencyinput-left-addon", variant: "light" }),
      ...e
    }
  );
});
i.displayName = "CurrencyInput";
export {
  i as CurrencyInput
};
